import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from 'react';
import { cn } from '../utils/cn.js';
const TONE = {
    info: 'border-border border-l-4 border-l-forest bg-forest/[0.045] text-ink',
    success: 'border-border border-l-4 border-l-success bg-success/[0.05] text-ink',
    warning: 'border-border border-l-4 border-l-warning bg-warning/[0.055] text-ink',
    danger: 'border-border border-l-4 border-l-danger bg-danger/[0.05] text-ink',
};
const ICON = {
    info: 'text-forest',
    success: 'text-success',
    warning: 'text-warning',
    danger: 'text-danger',
};
/**
 * Inline alert for form-level errors, missing-tax-info hints,
 * activation-blocked banners, etc. Use `role="status"` for non-error
 * tones; `role="alert"` for danger.
 */
export function Alert({ tone = 'info', title, className, children, ...rest }) {
    return (_jsxs("div", { role: tone === 'danger' ? 'alert' : 'status', className: cn('flex gap-3 rounded-md border px-4 py-3', TONE[tone], className), ...rest, children: [_jsx("svg", { className: cn('mt-0.5 h-5 w-5 flex-shrink-0', ICON[tone]), viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true", children: _jsx("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2h-1V9z", clipRule: "evenodd" }) }), _jsxs("div", { className: "flex-1 font-body text-sm", children: [title ? _jsx("p", { className: "mb-0.5 font-medium", children: title }) : null, _jsx("div", { className: title ? 'text-ink-muted' : '', children: children })] })] }));
}
//# sourceMappingURL=Alert.js.map